import moment from "moment";

export class GetGuestListItemsQuery {
  constructor(date, venueDetailsId) {
    let currentMoment = moment(date);
    // moment without time
    currentMoment = moment.utc([currentMoment.year(), currentMoment.month(), currentMoment.date()]);
    this.nightStart = currentMoment.toJSON();
    this.nightEnd = moment(this.nightStart).add(1, 'days').toJSON();

    this.venueDetailsId = venueDetailsId;
  }
}
